import VCProgramRequestDetail from './VCProgramRequestDetail';

export default VCProgramRequestDetail;
